import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { adminroutes } from './components/admin/admin-routing.module';
import { LanguageResolver } from './resolvers/language.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./components/login/login.module').then(m => m.LoginModule),
    resolve: {
      languages: LanguageResolver
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    resolve: {
      languages: LanguageResolver
    },
    children: [
      { path: 'home', loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule), data: { animation: 'home' } },
      { path: 'configurator', loadChildren: () => import('./components/configurator/configurator.module').then(m => m.ConfiguratorModule), data: { animation: 'configurator' } },
      { path: 'order', loadChildren: () => import('./components/config-order/config-order.module').then(m => m.AdminDelegationModule), data: { animation: 'order' } },
      { path: 'statistics', loadChildren: () => import('./components/statistic/statistic.module').then(m => m.StatisticModule), data: { animation: 'statistic' } },
      { path: 'admin', children: adminroutes },

    ]
  },
  { path: '**', redirectTo: '/home' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 0] // [x, y]
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
